import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationLargestArmyView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLargestArmyView'

export class UIWGamePlayerInformationLargestArmyView extends UIGamePlayerInformationLargestArmyView {
    protected createMyLargestArmyView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const largestArmyX = playerInformationW * 0.6707
        const largestArmyY = playerInformationH * 0.4833
        const largestArmyW = playerInformationW * 0.0915
        const largestArmyH = playerInformationH * 0.25

        const largestArmyCountX = playerInformationW * 0.6667
        const largestArmyCountY = playerInformationH * 0.77
        const largestArmyCountW = playerInformationW * 0.1003
        const largestArmyCountH = playerInformationH * 0.1

        const iconPadding = 0
        this.largestArmyView = new ItemCountView(largestArmyX, largestArmyY, largestArmyW, largestArmyH, this.playerInformation, this.largestArmyTexture,
            largestArmyCountX, largestArmyCountY, largestArmyCountW, largestArmyCountH, iconPadding)
    }

    protected createOpponentLargestArmyView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const largestArmyX = playerInformationW * 0.6707
        const largestArmyY = playerInformationH * 0.2155
        const largestArmyW = playerInformationW * 0.0915
        const largestArmyH = playerInformationH * 0.3879

        const largestArmyCountX = playerInformationW * 0.6707
        const largestArmyCountY = playerInformationH * 0.64
        const largestArmyCountW = playerInformationW * 0.0915
        const largestArmyCountH = playerInformationH * 0.1

        const iconPadding = 0
        this.largestArmyView = new ItemCountView(largestArmyX, largestArmyY, largestArmyW, largestArmyH, this.playerInformation, this.largestArmyTexture,
            largestArmyCountX, largestArmyCountY, largestArmyCountW, largestArmyCountH, iconPadding)
    }
}
